import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
// core components
import Grid from "@material-ui/core/Grid";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomLinearProgress from "components/CustomLinearProgress/CustomLinearProgress.jsx";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import FormControl from "@material-ui/core/FormControl";
import Button from "components/CustomButtons/Button.jsx";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ListAltIcon from "@material-ui/icons/ListAlt";
import Paper from "@material-ui/core/Paper";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import { Close } from "@material-ui/icons";
import { Modal } from "@material-ui/core";
import moment from "moment";
import ImgsViewer from "react-images-viewer";
import Viewer from "react-viewer";
import Pagination from "@material-ui/lab/Pagination";
import _ from "lodash";
import Image from "../../assets/img/default.png";

import {
  fetchPtmGpsapirtSearch,
  fetchVideoData,
  fetchVideoDataContract,
  fetchLastUpdateCctv,
  fetchShipnamecallsign
} from "../../api/portal";
import { pushLoader } from "../../actions/main";
import image1 from "../../assets/img/1.jpg";
import image2 from "../../assets/img/2.jpg";
import image3 from "../../assets/img/3.jpg";
import image4 from "../../assets/img/4.jpg";
import image5 from "../../assets/img/5.jpg";
import { withRouter } from "react-router-dom";

const itemData = [
  {
    img: image1,
    title: "Channel 1",
    featured: false
  },
  {
    img: image2,
    title: "Channel 2",
    featured: false
  },
  {
    img: image3,
    title: "Channel 3",
    featured: false
  },
  {
    img: image4,
    title: "Channel 4",
    featured: false
  },
  {
    img: image5,
    title: "Channel 5",
    featured: true
  }
];

const styles = theme => ({
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(2)
  },
  paper: {
    flexGrow: 1,
    backgroundColor: "#ebebeb",
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    height: "450px"
  },
  container: {
    display: "flex",
    flexWrap: "nowrap",
    flexDirection: "row"
  },
  textField: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    width: 300,
    padding: 5
  },
  selected: {
    color: "#6b7280",
    "&.Mui-selected": {
      color: "#000000",
      background: "rgb(207, 223, 255)"
    },
    "&:hover,&:focus": {
      color: "#000000"
    }
  }
});

const styleImage = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  // width: 400,
  bgcolor: "background.paper",
  // border: '2px solid #000',
  boxShadow: 24,
  p: 4
};

const styleButton = {
  position: "absolute",
  top: "8px",
  right: "16px",
  fontSize: "50px",
  color: "#FFF",
  cursor: "pointer"
};

class cctvHistori extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      loader: null,
      startDate: moment()
        .subtract(1, "days")
        .format("YYYY-MM-DDTHH:mm"),
      endDate: moment().format("YYYY-MM-DDTHH:mm"),
      callsign: "",
      dataVessel: [],
      dataVideo: [],
      dataFilter: [],
      selectedChannel: "001",
      ship_id: "",
      shipname: "-",
      call_sign: "-",
      photokapal: Image,
      lastupdate: "-",
      openImage: false,
      images: [],
      currImg: null,
      nodata: true,
      paging: 1,
      totalpage: 0,
      cctvToken: ""
    };
  }

  UNSAFE_componentWillMount() {
    fetchShipnamecallsign()
      .then(response => {
        this.setState({ dataVessel: response.data.results });
      })
      .catch(error => {
        console.log(error);
        //this.props.history.push("/pages/login#logout");
      });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    //console.log(nextProps.cctvToken);
    if (nextProps.cctvHistoris.length > 1) {
      if (nextProps.cctvHistoris[0] !== "-") {
        this.setState({
          search:
            nextProps.cctvHistoris[0] + " (" + nextProps.cctvHistoris[1] + ")",
          callsign: nextProps.cctvHistoris[1],
          shipname: nextProps.cctvHistoris[0]
        });
      } else {
        this.setState({
          search: nextProps.cctvHistoris[1],
          callsign: nextProps.cctvHistoris[1]
        });
      }
      let start = nextProps.cctvHistoris[2];
      let startx =
        start.substring(0, 4) +
        "-" +
        start.substring(4, 6) +
        "-" +
        start.substring(6, 8) +
        "T" +
        start.substring(8, 10) +
        ":" +
        start.substring(10, 12);
      let startxx = moment(startx, "YYYY-MM-DDTHH:mm")
        .subtract(1, "hours")
        .format("YYYY-MM-DDTHH:mm");
      this.setState({ startDate: startxx });

      let end = nextProps.cctvHistoris[3];
      let endx =
        end.substring(0, 4) +
        "-" +
        end.substring(4, 6) +
        "-" +
        end.substring(6, 8) +
        "T" +
        end.substring(8, 10) +
        ":" +
        end.substring(10, 12);
      let endxx = moment(endx, "YYYY-MM-DDTHH:mm").format("YYYY-MM-DDTHH:mm");
      this.setState({
        endDate: endxx
      });
      this.handleShowReport(
        nextProps.cctvHistoris[1],
        startxx,
        endxx,
        nextProps.cctvToken
      );

      this.getImageRedux(
        startxx,
        endxx,
        nextProps.cctvHistoris[1],
        nextProps.cctvToken
      );
    }
    if (nextProps.cctvMap.length > 1) {
      if (nextProps.cctvMap[0] === "no cctv found") {
        this.setState({
          search: nextProps.cctvMap[1] + " (" + nextProps.cctvMap[2] + ")",
          shipname: nextProps.cctvMap[1],
          callsign: nextProps.cctvMap[2]
        });
        this.handleShow();
      } else {
        this.setState({
          search: nextProps.cctvMap[0] + " (" + nextProps.cctvMap[1] + ")",
          callsign: nextProps.cctvMap[1],
          shipname: nextProps.cctvMap[0]
        });
        let start = nextProps.cctvMap[2];
        let startx =
          start.substring(0, 4) +
          "-" +
          start.substring(4, 6) +
          "-" +
          start.substring(6, 8) +
          "T" +
          start.substring(8, 10) +
          ":" +
          start.substring(10, 12) +
          ":" +
          start.substring(12, 14);
        let startxx = moment(startx, "YYYY-MM-DDTHH:mm")
          .subtract(1, "hours")
          .format("YYYY-MM-DDTHH:mm");
        this.setState({ startDate: startxx });

        let end = nextProps.cctvMap[3];
        let endx =
          end.substring(0, 4) +
          "-" +
          end.substring(4, 6) +
          "-" +
          end.substring(6, 8) +
          "T" +
          end.substring(8, 10) +
          ":" +
          end.substring(10, 12) +
          ":" +
          end.substring(12, 14);
        let endxx = moment(endx, "YYYY-MM-DDTHH:mm").format("YYYY-MM-DDTHH:mm");
        this.setState({
          endDate: endxx
        });
        this.handleShowReport(
          nextProps.cctvMap[1],
          startxx,
          endxx,
          nextProps.cctvToken
        );
        this.getImageRedux(
          startxx,
          endxx,
          nextProps.cctvMap[1],
          nextProps.cctvToken
        );
      }
    }
  }

  //get image by redux

  getImageRedux = (startDate, endDate, callsign, token) => {
    if (typeof token == "undefined") {
      return false;
    }

    fetchVideoData(
      startDate.replace("T", " "),
      endDate.replace("T", " "),
      callsign,
      token
    )
      .then(response => {
        if (response != null) {
          if (response.data.error == "callsign not found!") {
            fetchVideoDataContract(
              startDate.replace("T", " "),
              endDate.replace("T", " "),
              callsign,
              token
            )
              .then(response => {
                if (response != null) {
                  if (response.data.error == "callsign not found!") {
                    this.setState({ dataVideo: [] });
                  } else {
                    this.setState({ dataVideo: response.data.data });
                  }
                }
              })
              .catch(error => {
                this.setState({ dataVideo: [] });
                console.log(error);
                //this.props.history.push("/pages/login#logout");
              });
          } else {
            this.setState({ dataVideo: response.data.data });
            //this.props.pushVideoData(this.state.dataVideo);
          }
        }
      })
      .catch(error => {
        this.setState({ dataVideo: [] });
        //this.props.history.push("/pages/login#logout");
      });
  };

  getDataVessel(search) {
    if (search == "") {
      return false;
    }

    fetchPtmGpsapirtSearch(search)
      .then(response => {
        if (response != null) {
          response.data.results.map(e => {
            this.setState({
              // photokapal: `https://images.marinetraffic.com/collection/${
              //   e.ship_id
              // }.webp?size=800`
              photokapal: `https://www.marinetraffic.com/getAssetDefaultPhoto/?photo_size=300&asset_id=${
                e.ship_id
              }&asset_type_id=0`
            });
            fetchLastUpdateCctv(this.state.shipname)
              .then(response2 => {
                if (response2 != null) {
                  response2.data.results.map(ee => {
                    let datefixx = ee.ch1;
                    let datefixy =
                      datefixx.substring(0, 4) +
                      "-" +
                      datefixx.substring(4, 6) +
                      "-" +
                      datefixx.substring(6, 8) +
                      " " +
                      datefixx.substring(8, 10) +
                      ":" +
                      datefixx.substring(10, 12) +
                      ":" +
                      datefixx.substring(12, 14);
                    let datefixxx = moment(
                      datefixy,
                      "DD-MM-YYYY H:mm:ss"
                    ).format("DD-MM-YYYY H:mm:ss");
                    this.setState({ lastupdate: datefixxx });
                  });
                }
              })
              .catch(error2 => {
                //this.props.pushToken(error);
                //this.props.history.push("/pages/login#logout");
              });
          });
        }
      })
      .catch(error => {
        //this.props.pushToken(error);
        //this.props.history.push("/pages/login#logout");
      });
  }

  handlechangePage = (event, value) => {
    this.setState({ paging: value });
  };

  handleListItemClick = async (event, index) => {
    this.setState({
      selectedChannel: index,
      dataVideo: [],
      dataFilter: [],
      totalpage: 0,
      images: [],
      currImg: 0
    });

    let start = new Date(this.state.startDate);
    let end = new Date(this.state.endDate);

    let timeStart = moment(start, "YYYY-MM-DD HH:mm").format(
      "YYYY-MM-DD HH:mm"
    );
    let timeEnd = moment(end, "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm");

    fetchVideoData(
      timeStart,
      timeEnd,
      this.state.callsign,
      this.state.cctvToken
    )
      .then(response => {
        this.setState({ itemData: [] });

        if (response != null) {
          if (response.data.error == "callsign not found!") {
            fetchVideoDataContract(
              this.state.startDate.replace("T", " "),
              this.state.endDate.replace("T", " "),
              this.state.callsign,
              this.state.cctvToken
            )
              .then(response => {
                if (response != null) {
                  if (response.data.error == "callsign not found!") {
                    this.setState({
                      dataVideo: [],
                      nodata: false
                    });
                  } else {
                    // ini dia filternya
                    let dataVideo = response.data.data;

                    const searchFilter = "" + index + "_";
                    const escapeRegExp = str =>
                      str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

                    // const result = dataVideo.filter(value =>
                    //   new RegExp(`\\b${escapeRegExp(searchFilter)}`, "i").test(
                    //     value
                    //   )
                    // );
                    const result = dataVideo.filter(link => {
                      return link
                        .split("/")
                        .some(part => part.includes(searchFilter));
                    });
                    //console.log(result);

                    //ini dia

                    let temp = [];
                    result.map(item => {
                      temp.push({ src: item });
                    });
                    let totalpage = result.length / 12;
                    let sorted = _.sortBy(temp, ["src"]);
                    this.setState({
                      dataFilter: _.sortBy(result),
                      images: sorted,
                      totalpage: Math.ceil(totalpage)
                    });

                    this.setState({
                      dataVideo: response.data.data,
                      nodata: true
                    });
                  }
                }
              })
              .catch(error => {
                this.setState({
                  dataVideo: [],
                  nodata: false
                });
                console.log(error);
                //this.props.history.push("/pages/login#logout");
              });
          } else {
            this.setState({
              dataVideo: response.data.data,
              nodata: true
            });

            // ini dia filternya
            let dataVideo = response.data.data;

            const searchFilter = "" + index + "_";
            const escapeRegExp = str =>
              str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

            // const result = dataVideo.filter(value =>
            //   new RegExp(`\\b${escapeRegExp(searchFilter)}`, "i").test(value)
            // );
            const result = dataVideo.filter(link => {
              return link.split("/").some(part => part.includes(searchFilter));
            });

            let temp = [];
            result.map(item => {
              temp.push({ src: item });
            });
            let totalpage = result.length / 12;
            let sorted = _.sortBy(temp, ["src"]);
            this.setState({
              dataFilter: _.sortBy(result),
              images: sorted,
              totalpage: Math.ceil(totalpage)
            });
          }
        }
      })
      .catch(error => {
        this.setState({
          dataVideo: [],
          nodata: false
        });
        console.log(error);
        //this.props.history.push("/pages/login#logout");
      });

    // // ini dia filternya
    // let dataVideo = this.state.dataVideo;

    // const searchFilter = "" + index + "_";
    // const escapeRegExp = str => str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

    // // const result = dataVideo.filter(value =>
    // //   new RegExp(`\\b${escapeRegExp(searchFilter)}`, "i").test(value)
    // // );

    // const result = dataVideo.filter(link => {
    //   return link.split("/").some(part => part.includes(searchFilter));
    // });

    // let temp = [];
    // result.map(item => {
    //   temp.push({ src: item });
    // });

    // let totalpage = parseInt(result.length) / 12;

    // let sorted = _.sortBy(temp, ["src"]);

    // this.setState({
    //   dataFilter: _.sortBy(result),
    //   images: sorted,
    //   totalpage: Math.ceil(totalpage)
    // });
  };

  handleStartDate = e => {
    this.setState({ startDate: e.target.value });
  };

  handleEndDate = e => {
    this.setState({ endDate: e.target.value });
  };

  handleShowReport = (callsign, startx, endx, token) => {
    if (typeof token == "undefined") {
      return false;
    }
    this.getDataVessel(this.state.shipname);
    this.setState({ dataVideo: [], dataFilter: [], images: [], currImg: 0 });
    let start = new Date(startx);
    let end = new Date(endx);

    let timeStart = moment(start, "YYYY-MM-DD HH:mm").format(
      "YYYY-MM-DD HH:mm"
    );
    let timeEnd = moment(end, "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm");

    fetchVideoData(timeStart, timeEnd, callsign, token)
      .then(response => {
        this.setState({ itemData: [] });

        if (response != null) {
          if (response.data.error == "callsign not found!") {
            fetchVideoDataContract(
              this.state.startDate.replace("T", " "),
              this.state.endDate.replace("T", " "),
              this.state.callsign,
              token
            )
              .then(response => {
                if (response != null) {
                  if (response.data.error == "callsign not found!") {
                    this.setState({
                      dataVideo: [],
                      nodata: false
                    });
                  } else {
                    // ini dia filternya
                    let dataVideo = response.data.data;

                    const searchFilter = "001";
                    const escapeRegExp = str =>
                      str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

                    // const result = dataVideo.filter(value =>
                    //   new RegExp(`\\b${escapeRegExp(searchFilter)}`, "i").test(
                    //     value
                    //   )
                    // );
                    const result = dataVideo.filter(link => {
                      return link
                        .split("/")
                        .some(part => part.includes(searchFilter));
                    });
                    //console.log(result);

                    //ini dia

                    let temp = [];
                    result.map(item => {
                      temp.push({ src: item });
                    });
                    let totalpage = result.length / 12;
                    let sorted = _.sortBy(temp, ["src"]);
                    this.setState({
                      dataFilter: _.sortBy(result),
                      images: sorted,
                      totalpage: Math.ceil(totalpage)
                    });

                    this.setState({
                      dataVideo: response.data.data,
                      nodata: true
                    });
                  }
                }
              })
              .catch(error => {
                this.setState({
                  dataVideo: [],
                  nodata: false
                });
                console.log(error);
                //this.props.history.push("/pages/login#logout");
              });
          } else {
            this.setState({
              dataVideo: response.data.data,
              nodata: true
            });

            // ini dia filternya
            let dataVideo = response.data.data;

            const searchFilter = "001_";
            const escapeRegExp = str =>
              str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

            // const result = dataVideo.filter(value =>
            //   new RegExp(`\\b${escapeRegExp(searchFilter)}`, "i").test(value)
            // );
            const result = dataVideo.filter(link => {
              return link.split("/").some(part => part.includes(searchFilter));
            });

            let temp = [];
            result.map(item => {
              temp.push({ src: item });
            });
            let totalpage = result.length / 12;
            let sorted = _.sortBy(temp, ["src"]);
            this.setState({
              dataFilter: _.sortBy(result),
              images: sorted,
              totalpage: Math.ceil(totalpage)
            });
          }
        }
      })
      .catch(error => {
        this.setState({
          dataVideo: [],
          nodata: false
        });
        console.log(error);
        //this.props.history.push("/pages/login#logout");
      });
  };

  handleShow = () => {
    this.getDataVessel(this.state.shipname);
    this.setState({
      dataVideo: [],
      dataFilter: [],
      totalpage: 0,
      images: [],
      currImg: 0
    });
    let start = new Date(this.state.startDate);
    let end = new Date(this.state.endDate);

    let timeStart = moment(start, "YYYY-MM-DD HH:mm").format(
      "YYYY-MM-DD HH:mm"
    );
    let timeEnd = moment(end, "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm");

    fetchVideoData(
      timeStart,
      timeEnd,
      this.state.callsign,
      this.state.cctvToken
    )
      .then(response => {
        this.setState({ itemData: [] });

        if (response != null) {
          if (response.data.error == "callsign not found!") {
            fetchVideoDataContract(
              this.state.startDate.replace("T", " "),
              this.state.endDate.replace("T", " "),
              this.state.callsign,
              this.state.cctvToken
            )
              .then(response => {
                if (response != null) {
                  if (response.data.error == "callsign not found!") {
                    this.setState({
                      dataVideo: [],
                      nodata: false
                    });
                  } else {
                    // ini dia filternya
                    let dataVideo = response.data.data;

                    const searchFilter = "001";
                    const escapeRegExp = str =>
                      str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

                    // const result = dataVideo.filter(value =>
                    //   new RegExp(`\\b${escapeRegExp(searchFilter)}`, "i").test(
                    //     value
                    //   )
                    // );
                    const result = dataVideo.filter(link => {
                      return link
                        .split("/")
                        .some(part => part.includes(searchFilter));
                    });
                    //console.log(result);

                    //ini dia

                    let temp = [];
                    result.map(item => {
                      temp.push({ src: item });
                    });
                    let totalpage = result.length / 12;
                    let sorted = _.sortBy(temp, ["src"]);
                    this.setState({
                      dataFilter: _.sortBy(result),
                      images: sorted,
                      totalpage: Math.ceil(totalpage)
                    });

                    this.setState({
                      dataVideo: response.data.data,
                      nodata: true
                    });
                  }
                }
              })
              .catch(error => {
                this.setState({
                  dataVideo: [],
                  nodata: false
                });
                console.log(error);
                //this.props.history.push("/pages/login#logout");
              });
          } else {
            this.setState({
              dataVideo: response.data.data,
              nodata: true
            });

            // ini dia filternya
            let dataVideo = response.data.data;

            const searchFilter = "001_";
            const escapeRegExp = str =>
              str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

            // const result = dataVideo.filter(value =>
            //   new RegExp(`\\b${escapeRegExp(searchFilter)}`, "i").test(value)
            // );
            const result = dataVideo.filter(link => {
              return link.split("/").some(part => part.includes(searchFilter));
            });

            let temp = [];
            result.map(item => {
              temp.push({ src: item });
            });
            let totalpage = result.length / 12;
            let sorted = _.sortBy(temp, ["src"]);
            this.setState({
              dataFilter: _.sortBy(result),
              images: sorted,
              totalpage: Math.ceil(totalpage)
            });
          }
        }
      })
      .catch(error => {
        this.setState({
          dataVideo: [],
          nodata: false
        });
        console.log(error);
        //this.props.history.push("/pages/login#logout");
      });
  };

  handleImageView = index => {
    this.setState({ openImage: true, currImg: index });

    // console.log(this.state.images);
    // console.log(this.state.openImage);
  };

  renderImagenya = (e, index) => {
    //console.log(index);
    let splitdate = e.split("/");
    let datefix = splitdate[splitdate.length - 1].split("_");
    let datefixx = datefix[1].replace(".jpg", "");
    let datefixy =
      datefixx.substring(0, 4) +
      "-" +
      datefixx.substring(4, 6) +
      "-" +
      datefixx.substring(6, 8) +
      " " +
      datefixx.substring(8, 10) +
      ":" +
      datefixx.substring(10, 12) +
      ":" +
      datefixx.substring(12, 14);

    let datefixxx = moment(datefixy, "YYYY-MM-DD HH:mm").format(
      "DD-MM-YYYY HH:mm"
    );

    if (
      index >= (this.state.paging - 1) * 12 &&
      index < 12 * this.state.paging
    ) {
      return (
        <Grid item xs={12} md={2}>
          <Card
            style={{ padding: 10 }}
            onClick={() => this.handleImageView(index)}
          >
            <CardMedia component="img" height="140" image={e} />

            <CardContent>
              <Typography>{datefixxx}</Typography>
            </CardContent>
          </Card>
        </Grid>
      );
    } else {
      return;
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <div style={{ justifyContent: "center" }}>
              <Typography
                style={{
                  textAlign: "center",
                  flex: 1,
                  fontSize: "28px",
                  fontWeight: 500
                }}
              >
                <font>CCTV File Manager</font>
              </Typography>
              <CustomLinearProgress
                variant="determinate"
                color="gray"
                value={0}
                style={{ width: "40%", display: "inline-block" }}
              />
              <CustomLinearProgress
                variant="determinate"
                color="info"
                value={100}
                style={{ width: "20%", display: "inline-block" }}
              />
              <CustomLinearProgress
                variant="determinate"
                color="gray"
                value={0}
                style={{ width: "40%", display: "inline-block" }}
              />
              <br />
            </div>
          </GridItem>
          <Grid item xs={12}>
            <Paper elevation={0} className={classes.content}>
              <Grid container justify="center" spacing={2}>
                <Grid item xs={12} md={2}>
                  <div>
                    <img
                      height="200"
                      width="100%"
                      src={this.state.photokapal}
                      onError={() => this.setState({ photokapal: Image })}
                    />
                    <Typography color="textSecondary" align="center">
                      {this.state.shipname}
                    </Typography>
                    <Typography align="center">
                      Call Sign {this.state.callsign}
                    </Typography>
                    {/* <Typography color="textSecondary" align="center">
                      Last Update in: {this.state.lastupdate}
                    </Typography> */}
                  </div>
                  <div>
                    <List component="nav" aria-label="cctv-channel">
                      <ListItem
                        button
                        selected={this.state.selectedChannel === "001"}
                        onClick={event =>
                          this.handleListItemClick(event, "001")
                        }
                        className={classes.selected}
                      >
                        <ListItemIcon>
                          <ListAltIcon />
                        </ListItemIcon>
                        <ListItemText primary="AJG" />
                      </ListItem>
                      <ListItem
                        button
                        selected={this.state.selectedChannel === "002"}
                        onClick={event =>
                          this.handleListItemClick(event, "002")
                        }
                        className={classes.selected}
                      >
                        <ListItemIcon>
                          <ListAltIcon />
                        </ListItemIcon>
                        <ListItemText primary="BRT" />
                      </ListItem>
                      <ListItem
                        button
                        selected={this.state.selectedChannel === "003"}
                        onClick={event =>
                          this.handleListItemClick(event, "003")
                        }
                        className={classes.selected}
                      >
                        <ListItemIcon>
                          <ListAltIcon />
                        </ListItemIcon>
                        <ListItemText primary="CCR" />
                      </ListItem>
                      <ListItem
                        button
                        selected={this.state.selectedChannel === "004"}
                        onClick={event =>
                          this.handleListItemClick(event, "004")
                        }
                        className={classes.selected}
                      >
                        <ListItemIcon>
                          <ListAltIcon />
                        </ListItemIcon>
                        <ListItemText primary="ECR" />
                      </ListItem>
                      <ListItem
                        button
                        selected={this.state.selectedChannel === "005"}
                        onClick={event =>
                          this.handleListItemClick(event, "005")
                        }
                        className={classes.selected}
                      >
                        <ListItemIcon>
                          <ListAltIcon />
                        </ListItemIcon>
                        <ListItemText primary="WKN" />
                      </ListItem>

                      <ListItem
                        button
                        selected={this.state.selectedChannel === "006"}
                        onClick={event =>
                          this.handleListItemClick(event, "006")
                        }
                        className={classes.selected}
                      >
                        <ListItemIcon>
                          <ListAltIcon />
                        </ListItemIcon>
                        <ListItemText primary="WKR" />
                      </ListItem>
                    </List>
                  </div>
                </Grid>
                <Grid item xs={12} md={10}>
                  <br />
                  <div style={{ display: "flex", flexWrap: "wrap" }}>
                    <Grid item xs={12} md={4}>
                      <div style={{ paddingLeft: 30 }}>
                        <Autocomplete
                          inputValue={this.state.search}
                          onInputChange={(event, newInputValue) => {
                            this.setState({ search: newInputValue });

                            let callsignnya = newInputValue.split(" (");
                            if (callsignnya.length > 1) {
                              this.setState({
                                shipname: callsignnya[0],
                                callsign: callsignnya[1].slice(0, -1)
                              });
                            }
                          }}
                          id="controllable-states-demo"
                          options={this.state.dataVessel}
                          getOptionLabel={option =>
                            option.shipname + " (" + option.call_sign + ")"
                          }
                          renderInput={params => (
                            <TextField
                              {...params}
                              label="Search"
                              //variant="filled"
                              style={{ width: "100%", paddingBottom: 1 }}
                            />
                          )}
                        />
                      </div>
                    </Grid>
                    <Grid item xs={12} md={8}>
                      <div style={{ paddingRight: 30 }}>
                        <Grid item>
                          <form className={classes.container} noValidate>
                            <FormControl
                              size="small"
                              style={{
                                paddingBottom: 6,
                                paddingLeft: 15,
                                display: "flex",
                                flexDirection: "row"
                              }}
                            >
                              <TextField
                                size="small"
                                id="datetime-local"
                                label="Start Date"
                                type="datetime-local"
                                className={classes.textField}
                                defaultValue={this.state.startDate}
                                InputLabelProps={{
                                  shrink: true
                                }}
                                inputProps={{
                                  value: this.state.startDate,
                                  onChange: this.handleStartDate
                                }}
                              />
                              <TextField
                                size="small"
                                id="datetime-local"
                                label="End Date"
                                type="datetime-local"
                                className={classes.textField}
                                defaultValue={this.state.endDate}
                                InputLabelProps={{
                                  shrink: true
                                }}
                                inputProps={{
                                  value: this.state.endDate,
                                  onChange: this.handleEndDate
                                }}
                              />
                            </FormControl>
                            <FormControl
                              size="small"
                              style={{
                                paddingBottom: 6,
                                display: "flex"
                              }}
                            >
                              <Button
                                variant="outlined"
                                color="behance"
                                round
                                onClick={this.handleShow}
                              >
                                Show
                              </Button>
                            </FormControl>
                          </form>
                        </Grid>
                      </div>
                    </Grid>
                  </div>
                  <div>
                    <Grid item xs={12} md={12}>
                      <div hidden={this.state.nodata}>
                        <Typography>No Data</Typography>
                      </div>

                      <Pagination
                        color="primary"
                        count={this.state.totalpage}
                        showFirstButton
                        showLastButton
                        onChange={this.handlechangePage}
                      />

                      <Grid
                        container
                        //justify="center"
                        spacing={2}
                        style={{ paddingTop: "15px", paddingLeft: "15px" }}
                      >
                        {this.state.dataFilter.map(this.renderImagenya)}
                      </Grid>
                    </Grid>
                    <Viewer
                      images={this.state.images}
                      // currImg={this.state.currImg}
                      visible={this.state.openImage}
                      activeIndex={this.state.currImg}
                      // onClickPrev={() => this.setState({currImg: this.state.currImg - 1})}
                      // onClickNext={() => this.setState({currImg: this.state.currImg + 1})}
                      onClose={() => this.setState({ openImage: false })}
                      zIndex={100000}
                    />
                  </div>
                  {/* <Modal open={this.state.openImage} onClose={() => this.setState({openImage: false})}>
                    <React.Fragment>
                    <Close style={styleButton} onClick={() => this.setState({openImage: false})}/>
                    <img style={styleImage} src={this.state.dataFilter[this.state.currImg]} />
                    </React.Fragment>
                  </Modal> */}
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </GridContainer>
      </div>
    );
  }
}

cctvHistori.propTypes = {
  pushLoader: PropTypes.bool
};

function mapStateToProps(state) {
  return {
    blocking: state.loader,
    cctvHistoris: state.cctvHistoris,
    cctvMap: state.cctvMap,
    cctvToken: state.cctvToken
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    {
      pushLoader
    }
  )(withStyles(styles)(cctvHistori))
);
